var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.geoCenter && _vm.infoWindowsList.length > 0
        ? [
            _c(
              "google-map",
              {
                ref: "Map",
                attrs: { id: "map", zoom: 10, center: _vm.geoCenter }
              },
              [
                _vm._l(_vm.infoWindowsList, function(infoWindow, index) {
                  return _c("google-map-marker", {
                    key: index,
                    attrs: {
                      position: infoWindow.position,
                      icon:
                        "/assets/web/images/marker_" +
                        infoWindow.marker +
                        ".png",
                      clickable: true
                    },
                    on: {
                      click: function($event) {
                        return _vm.toggleInfoWindow(infoWindow)
                      }
                    }
                  })
                }),
                _vm._v(" "),
                _c(
                  "google-map-infowindow",
                  {
                    attrs: {
                      id: "info-window",
                      position: _vm.infoWindowContext.position,
                      show: _vm.showInfo,
                      options: { maxWidth: 300 }
                    },
                    on: {
                      "update:show": function($event) {
                        _vm.showInfo = $event
                      },
                      "info-window-clicked": _vm.infoClicked
                    }
                  },
                  [
                    _c("div", [
                      _c("div", {
                        staticClass: "map-info-window",
                        domProps: {
                          innerHTML: _vm._s(_vm.infoWindowContext.description)
                        }
                      })
                    ])
                  ]
                )
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }